import React from 'react';
import { ChevronDown } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  DropdownMenuLabel,
  DropdownMenuSeparator,
} from './ui/dropdown-menu';
import { useCurrency, CURRENCY_OPTIONS } from '../contexts/CurrencyContext';

/**
 * Compact toggle for the global FCFA/EUR/USD currency. Shown in the Navbar.
 * Persisted via CurrencyContext (localStorage).
 */
const CurrencyToggle = () => {
  const { code, setCode, meta, usdSource } = useCurrency();
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          data-testid="currency-toggle"
          className="inline-flex items-center gap-1 px-2 py-1.5 rounded-xl text-xs font-semibold text-stone-700 hover:bg-stone-100 transition-colors"
          aria-label="Changer de devise"
        >
          <span aria-hidden>{meta.flag}</span>
          <span className="hidden sm:inline">{code}</span>
          <ChevronDown className="h-3 w-3 text-stone-400" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56">
        <DropdownMenuLabel className="text-label uppercase tracking-wider text-stone-500">
          Devise d'affichage
        </DropdownMenuLabel>
        {CURRENCY_OPTIONS.map((opt) => (
          <DropdownMenuItem
            key={opt.code}
            onClick={() => setCode(opt.code)}
            data-testid={`currency-opt-${opt.code}`}
            className={`flex items-center gap-2 cursor-pointer ${opt.code === code ? 'bg-brand-50 text-brand-700 font-semibold' : ''}`}
          >
            <span aria-hidden>{opt.flag}</span>
            <span className="flex-1">{opt.label}</span>
            <span className="text-label text-stone-500">{opt.code}</span>
          </DropdownMenuItem>
        ))}
        <DropdownMenuSeparator />
        <div className="px-2 py-1.5 text-label text-stone-500 leading-relaxed">
          EUR : taux fixe (655,957 FCFA = 1 €).<br />
          USD : {usdSource === 'live' ? 'taux du jour (open.er-api.com)' : usdSource === 'cache' ? 'taux du jour (cache)' : 'taux indicatif'}.
        </div>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default CurrencyToggle;
